module.exports = __webpack_public_path__ + "img/m-wash3pro-menu-desktop.40ee24ba.png";